// extracted by mini-css-extract-plugin
export default {"investments":"Investments_investments__0uX+f","loading":"Investments_loading__SjsRH","empty":"Investments_empty__HqchA"};